import { Component, OnDestroy, OnInit } from '@angular/core';
import { StreamService } from '../services';
import { takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, Data } from '@angular/router';
import { Subject, combineLatest } from 'rxjs';
import * as moment from 'moment';

@Component({
    template: `
        <div *ngIf="noTouching" fxLayoutAlign="center center" style="padding-top: 50px;"><spinner></spinner></div>
        <topic-summary-grid *ngIf="!noTouching" [topics]="topics"  [emptyMessage]="emptyMessage">
        </topic-summary-grid>
    `
})
export class BrowseCatalogCategoryTopicsPane implements OnInit, OnDestroy {
    noTouching = true;
    private cleanupTime = new Subject<void>();
    topics: any[];
    isNew: boolean;

    constructor(private streamService: StreamService, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.data.pipe(takeUntil(this.cleanupTime)).subscribe((data: Data) => {
            this.isNew = data.isNew;
        });
        combineLatest([
            this.route.params, 
            this.route.parent.parent.params])
        .pipe(takeUntil(this.cleanupTime))
        .subscribe(() => this.populate());
        this.populate();
    }

    get categoryId(): string {
        return this.route.snapshot.params.categoryId 
            || this.route.parent.snapshot.params.categoryId
            || this.route.parent.parent.snapshot.params.categoryId;
    }

    get emptyMessage(): string {
        return this.isNew ? 
            'No new topics have been added in the last 30 days.' : 
            'Your team hasn\'t created topics yet.';
    }

    populate() {
        this.noTouching = true;
        const params: { categoryId: string, rows: number, sort: string, sortDirection: string, createdAfterDateTime?: string} = { 
            categoryId: this.categoryId, 
            rows: 1000,
            sort: this.route.snapshot.queryParams.sort || 'title',
            sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc'
        };
        if (this.isNew) {
            params.createdAfterDateTime = moment().subtract(30, 'days').toISOString();
        }
        const catalogId = this.route.parent.parent.snapshot.params.catalogId || this.route.parent.parent.parent.snapshot.params.catalogId;
        this.streamService.getCatalogCategoryStreams(catalogId, params)
        .pipe(tap(() => this.noTouching = false))
        .subscribe(results => this.topics = results.content);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
